export default "__VITE_ASSET__DKNSA_4z__"